import { render } from "./QuizPage.vue?vue&type=template&id=a6b83a3c&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"

import "../../assets/styles/main.scss?vue&type=style&index=0&lang=scss&external"
import "./QuizPage.vue?vue&type=style&index=1&id=a6b83a3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b83a3c"]])

export default __exports__